var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row filter-functions-desktop" }, [
    _c("div", [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-9 filter-form-row" }, [
        _c("div", { staticClass: "form-inline" }, [
          _c(
            "span",
            { staticClass: "date-picker-wrapper" },
            [
              _c("datepicker", {
                attrs: {
                  "calendar-button": true,
                  "calendar-button-icon": "fa fa-calendar",
                  "clear-button": true,
                  "clear-button-icon": "fa fa-times",
                  "bootstrap-styling": true,
                  format: "yyyy MMM dd",
                  typeable: true
                },
                on: { input: _vm.changed },
                model: {
                  value: _vm.options.startDate,
                  callback: function($$v) {
                    _vm.$set(_vm.options, "startDate", $$v)
                  },
                  expression: "options.startDate"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "to-label" }, [_vm._v("to")]),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "date-picker-wrapper last" },
            [
              _c("datepicker", {
                attrs: {
                  "calendar-button": true,
                  "calendar-button-icon": "fa fa-calendar",
                  "clear-button": true,
                  "clear-button-icon": "fa fa-times",
                  "bootstrap-styling": true,
                  format: "yyyy MMM dd",
                  typeable: true
                },
                on: { input: _vm.changed },
                model: {
                  value: _vm.options.endDate,
                  callback: function($$v) {
                    _vm.$set(_vm.options, "endDate", $$v)
                  },
                  expression: "options.endDate"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "reverese-clerical-toggles" }, [
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.options.showReversed,
                    expression: "options.showReversed"
                  }
                ],
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.options.showReversed)
                    ? _vm._i(_vm.options.showReversed, null) > -1
                    : _vm.options.showReversed
                },
                on: {
                  change: [
                    function($event) {
                      var $$a = _vm.options.showReversed,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.options,
                              "showReversed",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.options,
                              "showReversed",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.options, "showReversed", $$c)
                      }
                    },
                    _vm.changed
                  ]
                }
              }),
              _vm._v(
                "\n                        Show reversed\n                    "
              )
            ]),
            _vm._v(" "),
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.options.showClerical,
                    expression: "options.showClerical"
                  }
                ],
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.options.showClerical)
                    ? _vm._i(_vm.options.showClerical, null) > -1
                    : _vm.options.showClerical
                },
                on: {
                  change: [
                    function($event) {
                      var $$a = _vm.options.showClerical,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.options,
                              "showClerical",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.options,
                              "showClerical",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.options, "showClerical", $$c)
                      }
                    },
                    _vm.changed
                  ]
                }
              }),
              _vm._v(
                "\n                        Show clerical\n                    "
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xs-3 text-right label-fixed-width" }, [
      _c("label", [_vm._v("Filters:")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46d9344e", { render: render, staticRenderFns: staticRenderFns })
  }
}